import styled from 'styled-components';
import { rem } from 'polished';
import { CardTitle } from 'reactstrap';
import { fontStyle, lineHeight } from '@whitelabel/helpers/style/type';
import { color } from '@whitelabel/helpers/style/colors';
import { borderRadius } from '@whitelabel/helpers/style/box';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { Button } from '@whitelabel/component-library';

export const StyledPartnerCard = styled.div`
  max-height: 100vh;
  overflow: auto;
`;

export const StyledCardTitle = styled(CardTitle)`
  text-transform: none;
  height: 19rem;
  padding: 1rem;
  width: 100%;
  background: ${color('ceruleanGradient')};
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  h1 {
    width: 100%;
    overflow-wrap: break-word;
    color: ${color('white')};
    ${fontStyle('secondaryH2')};
    line-height: ${lineHeight('headingsLg')};
    text-transform: none;
    margin-bottom: 0;
    :first-child {
      line-height: 3.3rem;
    }
  }

  ${mediaBreakpointUp('md')`
    height: ${rem(213)};
    padding: 0rem 6rem 2rem 2.5rem;
    flex-direction: column;

    align-items: center;
    justify-content:center;
  `}
`;

export const StyledHeaderText = styled.div`
  position: relative;
  height: 40%;
  ${mediaBreakpointUp('md')`
    width:65%;
    height:auto;
  `}
`;
export const StyledHeaderLottie = styled.div`
  position: relative;
  width: 100%;
  height: 60%;
  margin-top: 1.5rem;
  user-select: none;
  pointer-events: none;

  ${mediaBreakpointUp('md')`
    width:35%;
    height:100%;
    margin-left:-3rem;
    margin-top: 0.5rem;
    margin:auto;
  `}
`;
export const StyledLottieBox = styled.div`
  position: absolute;
  width: 15.5rem;
  top: -0.8rem;
  cursor: auto;
  ${mediaBreakpointUp('md')`
    width: 18rem;
    top: 2rem;
  `}
`;

export const StyledPartnersBlock = styled.div`
  padding: 1rem;
  ${mediaBreakpointUp('md')`  
    padding: 1.5rem 2.5rem 2.5rem;
  `}
`;

export const StyledPartnersBox = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  ${mediaBreakpointUp('md')`
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 2rem;
  `}

  > div {
    background-color: ${color('white')};
    border-radius: ${borderRadius('base')};
    opacity: 20%;
  }
`;

export const StyledBox = styled(Button)`
  position: relative;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  background-color: ${color('white')};
  width: 100%;
  flex-direction: row;
  padding: 1rem;

  ${mediaBreakpointUp('md')`
      flex-direction: column; 
      justify-content: center;
  `}

  > .image-wrapper ~ .image-box-title {
    ${mediaBreakpointUp('md')`
      margin-top:1rem;
    `}
  }

  .image-box-title {
    ${fontStyle('button')}
    display: flex;
    align-items: center;
    white-space: normal;
    text-align: start;
    word-break: break-word;
    height: auto;
    margin-top: 0;
    margin-bottom: 0;
  }

  > .image-wrapper {
    position: relative;
    display: flex;
    height: 2rem;
    width: 6rem;
    padding: 0;
    justify-content: center;
    margin-inline-end: 1rem;
    img {
      max-height: 2rem;
      ${mediaBreakpointUp('md')`
        max-height: 4rem;
      `}
    }

    ${mediaBreakpointUp('md')`
      align-items: center;
      justify-content: center;
      padding: 0 1rem;
      height: 4rem;
      width:100%; 
      margin-inline-end: 0;
    `}
  }

  > .image-box-image {
    height: 2rem;

    ${mediaBreakpointUp('md')`
        height:4rem;
    `}
  }
`;
